import React, { useCallback, useEffect, useState } from "react";
import { watchApi } from "../../api/auctiongate.js";

export default function WatchList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await watchApi.list();
      const arr = Array.isArray(r) ? r : r?.data ?? r?.items ?? [];
      setItems(Array.isArray(arr) ? arr : []);
    } catch (e) {
      // 4xx/5xx from AG should not look like a page-breaking error.
      if (e?.status && e.status >= 400 && e.status < 500) {
        setItems([]);
      } else {
        setError(e?.message || "Failed to load watch list");
        setItems([]);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return (
    <div className="card">
      <div className="card__title">
        Watch List
        <button className="btn btn-ghost" onClick={reload} disabled={loading} style={{ fontSize: 12, padding: "6px 12px" }}>
          {loading ? <span className="loader" /> : "Refresh"}
        </button>
      </div>

      {error && <div className="login-error">{error}</div>}

      {!error && !loading && items.length === 0 && (
        <div className="placeholder-panel">No watched lots yet.</div>
      )}

      {!error && items.length > 0 && (
        <div className="stack">
          {items.slice(0, 25).map((it, idx) => (
            <div
              key={it.id ?? it.lot_number ?? idx}
              style={{
                padding: "10px 12px",
                border: "1px solid var(--color-border)",
                borderRadius: 8,
                background: "var(--color-bg-card-elevated)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>
                  {it.title || it.name || it.vehicle || `Lot ${it.lot_number ?? "?"}`}
                </div>
                <div className="small muted">
                  {it.auction && <>Auction: <b>{it.auction}</b> · </>}
                  {it.lot_number && <>Lot: <b>{it.lot_number}</b> · </>}
                  {it.vin && <>VIN: <span style={{ fontFamily: "monospace" }}>{it.vin}</span></>}
                </div>
              </div>
              {it.lot_number && (
                <button
                  className="btn btn-ghost"
                  style={{ fontSize: 12, padding: "6px 10px" }}
                  onClick={async () => {
                    try {
                      await watchApi.remove({ lot_number: it.lot_number, auction: it.auction });
                      await reload();
                    } catch {}
                  }}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
          {items.length > 25 && (
            <div className="small muted text-center">…and {items.length - 25} more</div>
          )}
        </div>
      )}
    </div>
  );
}
